import { render, staticRenderFns } from "./BancoPage.vue?vue&type=template&id=f590fa62"
import script from "./BancoPage.js?vue&type=script&lang=js&external"
export * from "./BancoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports